

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface PatientPrescriptionParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface PatientPrescription {
    id?: any;
    regId:string;
    visitId:number;
    medicineId:string;
    days?:number;
    mor:string;
    aft:string;
    eve:string;
    night:string;
    qty:number;
    takenAt?:string;
    instructions?:string;
    convInstructions?:string;
    medicineName?:string;
    tenantId: any;
    branchId: any;
    admissionId?: any;
    start?:any;
    stop?:any;
    activeStatus?:string;
    diagnosisId?:any;
    prescribedWhen?:string;
    parameters?: PatientPrescriptionParameter[];
    links?: any;
    //New
    pharmacyStatus?:string;
    dosage?:string;
    dosageunit?:string;
    advice?:string;
    duration?:string;
    durationUnit?:string;
    frequency?:string;
    docIdForQC?:string;
    presNameForQC?:string;
    routeMethod?:string;

    // discount related field:-
    totalDiscounttype?:string;
    totalDiscountPer?:number;
    totalDiscountAmt?:number;
    lineItemDiscounttype?:string;
    lineItemDiscountPer?:number;
    lineItemDiscountAmt?:number;
    unitSellPrice?:number;
    netamount?:number;
    drugIntakeRoute?:string;
    drugUsageArea?:string;
    drugIntakeAdvice?:string;
    drugIntakeMode?:string;
    phIndentNo?:string,
    //LOg
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    sortOrderId?:number;
    performingDoctor?:string;
    performingNurse?:string;
    prescribedDate?:Date|string|null;
    prescribedDoctor?:string|null;
}

export interface TreatmentOptions {
    value: string;
  }


export abstract class PatientPrescriptionData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<PatientPrescription[]>;
    abstract create(url: string, data: PatientPrescription): Observable<PatientPrescription[]>;
    abstract update(url: string, data: PatientPrescription): Observable<PatientPrescription>;
    abstract delete(url: string): Observable<any>;
    abstract settingscreate(url: string, data: any): Observable<any>;
}
